import { useRoute } from "vue-router";
import { apiGetJsTicketConfig } from "@/api";
import { onMounted } from "vue";
import { getQueryVariable } from "@/utils";
import { useStore } from "@/store";
import { WX } from "@/config";
import { ref } from "vue";
import { isDevelopment } from "@/store";
/**
 * @param {boolean} 免登录
 */
export default (noLogin = false) => {
  const route = useRoute();
  const store = useStore();
  const corpId = getQueryVariable("corpId") as string;
  const isInit = ref(false);
  const config = async (): Promise<void> => {
    console.log(route.query, route.query.corpId, corpId, corpId || (route.query.corpId as string));
    return new Promise((resolve) => {
      store.setLoading(true);
      wx.ready(async () => {
        await ready();
        resolve();
      });
      wxConfig(corpId || (route.query.corpId as string));
    });
  };
  const ready = async () => {
    try {
      store.setLoading(true);
      console.log(route, route.query, corpId);
      await wxConfig(corpId, true);
      if (!noLogin) {
        await store.setCorpId(corpId);
        await store.setEntry();
        await store.setExternal();
        await store.setPower();
      }
      isInit.value = true;
    } finally {
      store.setLoading(false);
    }
  };

  if (isDevelopment) setTimeout(ready, 500);
  return {
    isInit,
    config,
  };
};

export const wxConfig = async (corpId: string, isagent = false): Promise<void> => {
  return new Promise(async (resolve) => {
    const params = {
      corpId,
      url: location.href.split("#")[0], //.replace("http://", ""),
      isagent,
    };
    const { data } = await apiGetJsTicketConfig(params);
    console.log(data, isagent);
    if (!isagent)
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，企业微信的corpID
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [""], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
    else
      wx.agentConfig({
        corpid: data.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: [
          "previewFile",
          "sendChatMessage", //
          "getContext",
          WX.GET_CRU_EXTERNAL_CHAT,
          WX.GET_CUR_EXTERNAL_CONTACT,
          "createExternalPayment",
          "openEnterpriseChat",
          "shareToExternalContact",
          "openExistedChatWithMsg",
          "createChatWithMsg",
        ], //必填，传入需要使用的接口名称
        success: function (res: any) {
          // 回调
          console.log(res, "success");
        },
        fail: function (res: any) {
          console.log(res, "fail");
        },
        complete: function () {
          console.log("complete");
          resolve();
        },
      });

    if (isDevelopment) setTimeout(resolve, 500);
  });
};
